import { installModuleLoader } from "./moduleLoader";
import { installMetaRefresh } from "../shared/metaRefresh";

// The core: what many basic components need on their first interaction. The imports run in this order, which is
// the order the old scripts installed their document listeners in (DWSBlazorBase.js, then DWSBlazorUtils.js): some
// listeners look at defaultPrevented, so the order matters. A second copy of dws.js on the page runs none of this
// (build.mjs wraps the bundle in a check for window.dwsModules), so no listener is installed twice.
import "./logging";
import "./unload";
import "./layers";
import "./focus";
import "./page";
import "./haptics";
import "./clipboardGesture";
import "./tooltipTouch";
import "./input";
import "./theme";
import "./delegated";
import "./popupEngine";
import "./scrolling";
import "./focusHelpers";
import "./dom";
import "./behaviours";
import "./icons";
import "./lazyLoad";

// Entry of js/dws.js, the one classic script an app references: the module loader with the stand-ins for every
// lazily loaded name, plus the core above. Everything feature-specific lives in js/modules/ and loads on first use.

const script = document.currentScript as HTMLScriptElement | null;

installModuleLoader();

// DwsMetaTagEntry's refresh on statically rendered pages, which never load a module (was window.dwsMetaRefresh).
installMetaRefresh();

// <script src=".../dws.js" data-preload="richedit,map" data-preload-idle>: the app's opt-in preload list.
if (script && script.dataset.preload) {
    window.dwsModules.preload(script.dataset.preload, script.hasAttribute("data-preload-idle"));
}
